import React from 'react';

export function typeDataFormat(cell, row) {
  let icon = '';
  switch (row.type) {
    case 'youtube':
      icon = 'video.png';
      break;
    case 'article':
      icon = 'article.png';
      break;
    case 'feed':
      icon = 'blitzfeed.png';
      break;
    case 'guide':
      icon = 'guide.png';
      break;
    default:
      icon = '';
  }
  return (
    <div className="entry-item-type-icon"><img className="fit-height" role="presentation" src={`/assets/img/icons/${icon}`} /></div>
  );
}

export function esportDataFormat(cell, row) {
  return (
    <div className="entry-item-esport-icon"><img className="fit-height" role="presentation" src={`/assets/img/icons/${row.esport}.png`} /></div>
  );
}


// WEBPACK FOOTER //
// ./src/cms/entry/TableUtils.js